import { createFileRoute, notFound } from "@tanstack/react-router";
import { ComparisonLayout } from "@/components/ComparisonLayout";
import { getComparisonBySlug } from "@/lib/comparisons-data";
import { buildSeoMeta } from "@/lib/seo";

const SLUG = "baselinker-vs-sellasist";

export const Route = createFileRoute("/porownanie/baselinker-vs-sellasist")({
  head: () => {
    const c = getComparisonBySlug(SLUG)!;
    return buildSeoMeta({
      title: c.title,
      description: c.metaDescription,
      path: `/porownanie/${SLUG}`,
    });
  },
  component: () => {
    const c = getComparisonBySlug(SLUG);
    if (!c) throw notFound();
    return <ComparisonLayout data={c} />;
  },
});
